import MediaSearch from '../search';
import actions from './actions';
import mutations from './mutations';

function state() {
    return {
        options: [
            {
                label: 'All',
                key: 'category',
                value: null,
                reload: true
            },
        ],

        filter: {
            category: null,
            height: null,
            width: null
        },

        dialogsVisible: {
            assetGallery: false,
            templateGallery: false
        },

        preview: {
            mediaId: null,
            image: null
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};